import React from "react"

const StackProgressBar = ({
  series = [],
  height = 30,
  borderRadius = 6,
  backgroundColor = "#ECECEC",
  showLabels = true,
}) => {
  const MIN_SEGMENT_WIDTH = "40px"
  return (
    <div className="w-full pb-[14px]">
      <div
        className="flex w-full overflow-hidden"
        style={{
          height: `${height}px`,
          borderRadius:
            typeof borderRadius === "number" ?
              `${borderRadius}px`
            : borderRadius,
          background: backgroundColor,
        }}
      >
        {series.map((item, index) => (
          <div
            key={`${item.label}-${index}`}
            className="flex align-items-center justify-content-center text-white font-normal font-inter leading-[21px] text-[14px] stack-progress-segment"
            style={{
              flex: item.percentage,
              minWidth: item.percentage > 0 ? MIN_SEGMENT_WIDTH : 0,
              background: item.color,
            }}
          >
            {showLabels ? `${item.percentage}%` : null}
          </div>
        ))}
      </div>
    </div>
  )
}

export default StackProgressBar
